<div
  [class]="'configurable_link_list_element' + (item.isSelected?' k-state-selected':'') + (item.isHoveredOver?' k-state-hover':'')"
  *ngFor="let item of list"
  (mouseenter)="this.divMouseEnter($event, item)"
  (mouseleave)="this.divMouseLeave($event, item)"
  (click)="divClicked($event, item);">
  <a class="configurable_link_list_text_link">
    <span [class]="('configurable_link_list_text_content' + (item.isDefault?'_short':''))">{{item.textContent}}</span>
    <span *ngIf="item.isDefault" class="configurable_link_list_text_default"> (default)</span>
  </a>
  <a
  [class]="'cvt-icon-trash grid-status-icons' + (item.isHoveredOver?' k-state-hover':'')"
  (click)="this.deleteClicked($event, item);"></a>
</div>
